import React from 'react';

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6 text-white">서비스 약관</h1>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3 text-white">1. 약관의 적용</h2>
          <p className="text-gray-300 mb-2">
            본 약관은 My Radio DB(이하 "서비스")의 이용과 관련하여 서비스 제공자와 이용자 간의 권리,
            의무 및 책임사항을 규정함을 목적으로 합니다.
          </p>
          <p className="text-gray-300">서비스를 이용하시면 본 약관에 동의하는 것으로 간주됩니다.</p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3 text-white">2. 서비스의 제공</h2>
          <p className="text-gray-300 mb-2">서비스는 다음과 같은 기능을 제공합니다:</p>
          <ul className="list-disc list-inside text-gray-300 ml-4 mt-2 space-y-1">
            <li>배철수 음악캠프 그날의 선곡표 조회</li>
            <li>아티스트별 음악 검색 및 조회</li>
            <li>연도별/기간별 음악 순위 조회</li>
            <li>YouTube 플레이리스트 생성 기능 (Google OAuth 필요)</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3 text-white">3. 이용자의 의무</h2>
          <p className="text-gray-300 mb-2">이용자는 다음 행위를 하여서는 안 됩니다:</p>
          <ul className="list-disc list-inside text-gray-300 ml-4 mt-2 space-y-1">
            <li>서비스의 정상적인 운영을 방해하는 행위</li>
            <li>타인의 정보를 도용하는 행위</li>
            <li>법령 또는 공서양속에 반하는 행위</li>
            <li>서비스와 관련된 설비의 오동작이나 정보 등의 파괴 및 혼란을 유발하는 행위</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3 text-white">4. 서비스의 변경 및 중단</h2>
          <p className="text-gray-300">
            서비스 제공자는 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를
            변경하거나 중단할 수 있습니다. 서비스의 내용, 이용방법, 이용시간에 대하여 변경 또는
            중단이 있는 경우에는 사전에 공지하거나 통지하겠습니다.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3 text-white">5. 개인정보 보호</h2>
          <p className="text-gray-300">
            서비스 제공자는 이용자의 개인정보 보호를 위하여 노력합니다. 개인정보의 보호 및 사용에
            대해서는 관련법령 및 서비스의 개인정보처리방침이 적용됩니다. 자세한 내용은{' '}
            <a href="/privacy-policy" className="text-blue-400 hover:underline">
              개인정보처리방침
            </a>
            을 참고하시기 바랍니다.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3 text-white">6. 저작권</h2>
          <p className="text-gray-300">
            서비스에 게재된 모든 콘텐츠의 저작권은 원 저작자에게 있으며, 서비스 제공자는 이용자가
            게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3 text-white">7. 면책조항</h2>
          <p className="text-gray-300 mb-2">
            서비스 제공자는 다음 각 호의 사유로 인한 손해에 대하여는 책임을 지지 않습니다:
          </p>
          <ul className="list-disc list-inside text-gray-300 ml-4 mt-2 space-y-1">
            <li>천재지변 또는 이에 준하는 불가항력으로 인한 서비스 중단</li>
            <li>이용자의 귀책사유로 인한 서비스 이용의 장애</li>
            <li>서비스에 접속 또는 이용 과정에서 발생하는 개인적인 손해</li>
            <li>제3자가 불법적으로 서비스에 접속하거나 서비스를 이용함으로써 발생하는 손해</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3 text-white">8. 약관의 변경</h2>
          <p className="text-gray-300">
            본 약관은 서비스 제공자의 필요에 따라 변경할 수 있으며, 변경된 약관은 서비스 화면에
            공지하거나 기타의 방법으로 이용자에게 공지함으로써 효력을 발생합니다.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3 text-white">9. 문의</h2>
          <p className="text-gray-300">
            본 약관에 대한 문의사항이 있으시면{' '}
            <a
              href="https://www.threads.net/@yaongpainter"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:underline"
            >
              @Threads
            </a>
            로 문의해 주시기 바랍니다.
          </p>
        </section>

        <section>
          <p className="text-sm text-gray-300">시행일자: 2025년 1월 13일</p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
